import Cookies from 'js-cookie';
import React, { useState, useEffect } from "react";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Modal, ModalHeader, ModalBody } from "reactstrap";

// const openDevTool = () => {
//   console.log('%cCAUTION', 'color:red;')
// }

// class DevToolsChecker extends Error {
//   toString() {
//     return ''
//   }
//   get message() {
//     openDevTool()
//   }
// }
// console.log(new DevToolsChecker());

const RegisterModal = (props) => {
  const { currentUser } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenRegister = (e) => {
    e.preventDefault();
    $(".utf_signin_form .utf_tabs_nav li.signin-ref").removeClass("active")
    $(".utf_signin_form .utf_tabs_nav li.register-ref").addClass("active")
    $(".utf_signin_form #signin").hide();
    $(".utf_signin_form #register").show();
    $('.sign-in.popup-with-zoom-anim').magnificPopup('open');
  }

  useEffect(() => {
    const numViews = +(Cookies.get('views') || 0);
    // console.log('views', numViews)
    setIsOpen(!currentUser?.email && numViews > 3)
    const fpPromise = FingerprintJS.load()
    fpPromise.then(fp => fp.get()).then(result => {
      const visitorId = result.visitorId
      console.log( 'result', result, visitorId)
    })
  }, []);

  return (
    <Modal isOpen={isOpen} className="register-persistence" centered>
      <ModalBody>
        <div className="register-content">
          <a className="text-center"  onClick={handleOpenRegister}>
            <h2>
              Register for
              <br />
              Free NOW!
            </h2>
          </a>
          <div className="text-center">
            <p>
              Guests are limited to view 3 listings.
              <br />
              Join now to get UNLIMITED VIEWS  <br/>and FULL ACCESS.
            </p>
            <p>
              SwanPass is Thailand’s largest directory of adult businesses.
              We’re growing quickly across <br/>Southeast Asia — and the world!
            </p>
            <button className="button button-reverse" onClick={handleOpenRegister}>JOIN NOW!</button>
            <br/>
            {/* <a href="/" className='text-white'>
              back
            </a> */}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default RegisterModal;
